import React, {Component} from 'react';

import Left from './Left';
import Middle from './Middle';
import Right from './Right';
import Bottom from './Bottom';
import './marketplace.css';

class Marketplace extends Component {
  render() {
    return (
      <div className='minWidth container row marketplace'>
        <Left/>
        <Middle/>
        <Right/>
        <Bottom/>
      </div>
    );
  }
}

export default Marketplace
